module.exports = __webpack_public_path__ + "media/cuu/ppal_cuu_2_3-d5084888.jpg";